import { Lang } from "@/i18n-config";
import { getTranslations } from "@/utils/i18n/get-translations";

export const getTimeFrameOptions = ({ lang }: { lang: Lang }) => {
  const { t } = getTranslations(lang);
  return {
    overview: [
      { id: "Q", name: t.analysis.shared.dateOption.quarterly },
      { id: "Y", name: t.analysis.shared.dateOption.annually },
    ],
    financialReport: [
      { id: "Q", name: t.analysis.shared.dateOption.quarterly },
      { id: "4Q", name: t.analysis.shared.dateOption.fourQ },
      { id: "Y", name: t.analysis.shared.dateOption.annually },
    ],
    stockSentiment: [],
  };
};
